import React from 'react'
import {
  compose,
  pure,
  withProps,
  withStateHandlers,
  renderNothing,
  renameProp,
  lifecycle,
} from 'recompose'
import { connect } from 'react-redux'
import * as R from 'ramda'
import { Map } from 'immutable'
import { changeFormField } from 'sidecar-utility-library'

import InputBool from '../InputBool'
import InputScore from '../InputScore'
import InputSwitch from '../InputSwitch'
import ListSwitchItem from '../ListItem/ListSwitchItem'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

export const inputTypeMapping = {
  radio: props => <InputBool type="radio" {...props} />,
  checkbox: props => <InputBool type="checkbox" {...props} />,
  score: InputScore,
  switch: InputSwitch,
  listSwitchItem: ListSwitchItem,
}

const enhance = compose(
  renameProp('onChange', 'onChangeCallback'),
  toReduxFormField('InputListGeneral'),
  connect(null, { changeFormField }),
  withStateHandlers(
    {
      checkedItems: {},
    },
    {
      updateCheckedItems:
        (
          { checkedItems },
          { input: { onChange }, type, onChangeCallback = R.identity },
        ) =>
        (inputName, value) => {
          const isNilOrFalsy = R.either(R.isNil, R.not)
          const updatedItems = R.ifElse(
            isNilOrFalsy,
            () => R.dissoc(inputName, checkedItems),
            v => R.assoc(inputName, v, checkedItems),
          )(value)

          if (type === 'radio') {
            // unwrap `updateItems` and just get the `value`
            // because all radio value share same `label(name)`
            onChangeCallback(value)
            onChange(value)
          } else {
            onChangeCallback(updatedItems)
            onChange(updatedItems)
          }

          return { checkedItems: updatedItems }
        },
      initializeCheckItems:
        (_, props) =>
        (checkedItems = {}) => {
          const formName = props.meta.form
          Object.entries(checkedItems).map(([key, value]) =>
            props.changeFormField(formName, key, value),
          )
          return {
            checkedItems,
          }
        },
    },
  ),
  withProps(({ type }) => ({
    InputComponent: R.propOr(renderNothing(), type, inputTypeMapping),
  })),
  lifecycle({
    componentDidMount() {
      const initialValue = this.props.input.value
      const nextValue = Map.isMap(initialValue)
        ? initialValue.toJS()
        : initialValue

      this.props.initializeCheckItems(nextValue)
    },
    componentDidUpdate(prevProps) {
      if (
        JSON.stringify(this.props.input.value) !==
        JSON.stringify(prevProps.input.value)
      ) {
        const initialValue = this.props.input.value
        const nextValue = Map.isMap(initialValue)
          ? initialValue.toJS()
          : initialValue

        this.props.initializeCheckItems(nextValue)
      }
    },
  }),
  pure,
)

export default enhance
